import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PlusIcon } from "@heroicons/react/outline";
import BranchList from "../../components/Branch/views/BranchList";

const BranchManagement = () => {
  const navigate = useNavigate();
  const [view, setView] = useState("grid"); // grid or list

  return (
    <div className="space-y-6 sm:p-6 p-4">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Branch Management
            </h1>
            <p className="text-gray-600 mt-1">
              Manage your jewelry store branches and locations
            </p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => navigate("/branches/hierarchy")}
              className={`px-4 py-2 rounded-lg transition-colors bg-blue-600 text-white`}
            >
              Hierarchy
            </button>
            <button
              onClick={() => navigate("/branches/create")}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              <PlusIcon className="h-5 w-5" />
              Add Branch
            </button>
          </div>
        </div>
      </div>

      {/* Branch List */}
      <BranchList view={view} />
    </div>
  );
};

export default BranchManagement;
